export default {
    CLOSE: "close",
    BACK: "back",
    REWARD_SAVED: "reward_saved",
    REWARD_REMOVED: "reward_removed",
    REWARD_SUPPLIER_TYPE_SELECTED: "reward_supplier_type_selected",
};
